/* Pulmur reusable draggable slider.
   Activates on any [data-pulmur-slider] containing a [data-slider-track].
   Optional [data-slider-prev] / [data-slider-next] buttons.

   Desktop: mouse drag. We DON'T capture the pointer or preventDefault on
   press — only once the pointer actually moves past a threshold do we start
   dragging (capture + scroll). This keeps plain clicks/taps on the cards
   (Add to Cart, image, title links) working normally.
   Touch: left to the browser's native momentum scroll + CSS scroll-snap. */
(function () {
  var DIST_RATIO = 0.22;   // fraction of a slide that counts as "go to next"
  var FLICK_VEL  = 0.45;   // px/ms — a quick flick advances regardless of distance
  var DRAG_START = 6;      // px the mouse must move before it's treated as a drag

  function initSlider(root) {
    if (root.dataset.sliderReady === '1') return;
    var track = root.querySelector('[data-slider-track]');
    if (!track) return;
    root.dataset.sliderReady = '1';

    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');

    var pressed = false;
    var dragging = false;
    var justDragged = false;
    var startX = 0;
    var lastX = 0;
    var startScroll = 0;
    var startTime = 0;
    var pointerId = null;

    function slideStep() {
      var card = track.children[0];
      var w = card ? card.getBoundingClientRect().width : track.clientWidth * 0.8;
      var styles = getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap, 10);
      if (isNaN(gap)) gap = 20;
      return w + gap;
    }

    function maxIndex(step) {
      return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step));
    }

    function goTo(index, step) {
      var max = maxIndex(step);
      if (index < 0) index = 0;
      if (index > max) index = max;
      track.scrollTo({ left: index * step, behavior: 'smooth' });
    }

    function onDown(e) {
      /* Only hijack mouse drags — touch/pen keep smooth native scrolling. */
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.button !== undefined && e.button !== 0) return;
      pressed = true;
      dragging = false;
      justDragged = false;
      pointerId = e.pointerId;
      startX = lastX = e.clientX;
      startScroll = track.scrollLeft;
      startTime = Date.now();
      /* NB: no preventDefault / no capture here — let clicks happen. */
    }

    function onMove(e) {
      if (!pressed) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < DRAG_START) return;   // still just a click, not a drag
        dragging = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(pointerId); } catch (_) {}
      }
      lastX = e.clientX;
      track.scrollLeft = startScroll - dx;
      e.preventDefault();
    }

    function onUp() {
      if (!pressed) return;
      pressed = false;
      if (!dragging) return;                      // was a click — leave it alone
      dragging = false;
      justDragged = true;                         // suppress the click that follows
      track.classList.remove('is-dragging');
      try { if (pointerId != null) track.releasePointerCapture(pointerId); } catch (_) {}

      var step = slideStep();
      if (!step) return;
      var dragged = lastX - startX;
      var dt = Math.max(1, Date.now() - startTime);
      var velocity = dragged / dt;
      var idxFloat = track.scrollLeft / step;
      var startIndex = Math.round(startScroll / step);
      var target;

      if (velocity <= -FLICK_VEL) {
        target = Math.max(Math.ceil(idxFloat), startIndex + 1);
      } else if (velocity >= FLICK_VEL) {
        target = Math.min(Math.floor(idxFloat), startIndex - 1);
      } else {
        var frac = idxFloat - Math.floor(idxFloat);
        if (dragged < 0) {
          target = frac > DIST_RATIO ? Math.ceil(idxFloat) : Math.floor(idxFloat);
        } else if (dragged > 0) {
          target = (1 - frac) > DIST_RATIO ? Math.floor(idxFloat) : Math.ceil(idxFloat);
        } else {
          target = Math.round(idxFloat);
        }
      }
      goTo(target, step);
    }

    track.addEventListener('pointerdown', onDown);
    track.addEventListener('pointermove', onMove);
    track.addEventListener('pointerup', onUp);
    track.addEventListener('pointercancel', onUp);

    /* Only suppress the click that immediately follows a real drag. */
    track.addEventListener('click', function (e) {
      if (justDragged) { e.preventDefault(); e.stopPropagation(); justDragged = false; }
    }, true);

    if (next) next.addEventListener('click', function () {
      var step = slideStep();
      goTo(Math.round(track.scrollLeft / step) + 1, step);
    });
    if (prev) prev.addEventListener('click', function () {
      var step = slideStep();
      goTo(Math.round(track.scrollLeft / step) - 1, step);
    });

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var hasOverflow = max > 2;
      if (prev) prev.classList.toggle('is-hidden', !hasOverflow || track.scrollLeft <= 2);
      if (next) next.classList.toggle('is-hidden', !hasOverflow || track.scrollLeft >= max);
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-pulmur-slider]').forEach(initSlider);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
